
<script setup lang="ts">
import ProductDocuments from "@/vue_components/praeparate/shared/product-documents/product-documents.vue"
import DropdownPraeparate from "@/vue_components/praeparate/shared/dropdown-praeparate/dropdown-praeparate.vue"
import ProductdetailsRxImage from "@/vue_components/praeparate/produktdetails-rx/productdetails-rx-image/productdetails-rx-image.vue"
import {useProductDetailsRx} from "@/api/composables/useProductDetailsRx";
import {useProductDetailsCommon} from "@/api/composables/useProductDetailsCommon";


interface Props {
  productId: number
  praeparatId: number
}

const props = defineProps<Props>()

const {
  dictionary,
  praeparat,
  productData,
  isLoading,
  praeparatList,
  docLabel
} = useProductDetailsCommon(props.productId, props.praeparatId)

const { firstArtikel, fachweltUrl } = useProductDetailsRx(praeparat, dictionary)

</script>

<template>
  <div class="product-details-rx">
    <Loader v-if="isLoading"/>

    <div v-if="productData && praeparat" class="productDetailsContainer">
      <div v-if="dictionary" class="product-info product-info-rx">
        <div class="container">
          <div class="row rx">
            <div class="col-12 col-md-6 product-img">
              <productdetails-rx-image :praeparat="praeparat" :dictionary="dictionary" />
            </div>
            <div class="col-12 col-md-6 product-details">
              <h1 class="result-name">{{ praeparat?.name }}</h1>

              <div
                  v-if="praeparat?.anwendungsgebiet"
                  class="praeparat-indikation"
                  v-html="praeparat?.anwendungsgebiet"
              />

              <p class="produkte-label">{{ docLabel }}</p>

              <ProductDocuments :praeparat="praeparat!" :dictionary="dictionary" />

              <DropdownPraeparate v-if="praeparat !== null"
                                  :productName="productData.name ?? ''"
                                  :selected="praeparat"
                                  :praeparatList="praeparatList"
                                  :dictionary="dictionary"
                                  @select="praeparat = $event"
              />

              <div class="col-md-12 p-0" v-if="firstArtikel?.isRezeptpflichtig">
                <p class="warning-rx">
                  {{ dictionary['PRODUKTE_RezeptpflichtigHinweis'] ?? 'Rezeptpflichtiges Arzneimittel. Weitere Informationen für Fachkreise:' }}
                  <a
                      class="btn btn-simple"
                      :href="`https://${fachweltUrl}`"
                      target="_blank"
                      rel="noopener"
                  >
                    {{ dictionary['PRODUKTE_zurfachwelt'] ?? 'Zur Fachwelt für Fachkreise' }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container additional-data" v-if="praeparat?.patenthinweise && dictionary">
        <div class="row justify-content-md-center">
          <div class="col-12 col-md-8">
            <h3>{{ dictionary['PRODUKTE_Patenthinweise'] ?? 'Patenthinweise' }}</h3>
            <p v-html="praeparat?.patenthinweise" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Component-spezifische Styles */
</style>